export enum ZPrinterFiscalConfigPaymentType {
  cash = 'cash',
  cheque = 'cheque',
  card = 'card',
  wireTransfer = 'wire_transfer',
  singleTicket = 'single_ticket',
  multipleTickets = 'multiple_tickets',
  notCollected = 'not_collected',
  notCollectedGoods = 'not_collected_goods',
  notCollectedServices = 'not_collected_services',
  notCollectedInvoice = 'not_collected_invoice',
  notCollectedSnn = 'not_collected_snn',
  payDiscount = 'pay_discount',
  payDiscountVoucherMultiUse = 'pay_discount_voucher_multi_use',
}
